import styled from 'styled-components'
import * as appIcons from '../assets'

interface AppIconProps {
	readonly alt: string
	readonly width?: number
	readonly height?: number
	readonly type: keyof typeof appIcons | undefined
	readonly style?: object
}

const AppIcon = styled.img.attrs((props: AppIconProps) => {
	return {
		src: props.type ? appIcons[props.type] : '',
		alt: props.alt || props.type,
		width: props.width,
		height: props.height,
		loading: 'lazy',
		...props.style,
	}
})<AppIconProps>`
	object-fit: contain;
`

export { AppIcon }
